import { i18n } from '../i18n/index';

/** 根据特殊adtag设置特殊的document.title */
export const customDocumentTitle = {
/**
 * 场景：微信全球有礼小程序跳转至香港钱包优惠专区
 * tapd: https://tapd.woa.com/10145891/prong/stories/view/1010145891116362223
 * */
  wxpaygiftglobal: i18n('WeChat Pay HK優惠'),
};

/** 默认页面标题 */
export const defaultDocumentTitle = i18n('优惠专区');
